import {
  Cart,
  CartItemInterface,
} from '~/modules/GraphQL/types';

export const getItems = (cart: Cart): CartItemInterface[] => {
  if (!cart || !cart.itemsV2) {
    return [];
  }

  return cart.itemsV2.items;
};

export interface RequestQuoteCartGetters {
  getItems(cart: Cart): CartItemInterface[];
}

const requestQuoteCartGetters: RequestQuoteCartGetters = {
  getItems,
};

export default requestQuoteCartGetters;
